<template>
  <div :class="bem.b()">
    <a-input
      v-model:value="value"
      readonly
      :placeholder="placeholder"
      :bordered="bordered"
      :disabled="disabled"
      @click="showConfigModal"
    >
      <template #suffix>
        <ll-icon icon-name="icon-cron" />
      </template>
    </a-input>

    <CronModal
      ref="modalRef"
      v-model:value="editCronValue"
      :exe-start-time="exeStartTime"
      :hide-year="hideYear"
      :remote="remote"
      :hide-second="hideSecond"
      @ok="handleSubmit"
    />
  </div>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { Form } from 'ant-design-vue'
import { ref, watch } from 'vue'
import CronModal from './components/cron-modal.vue'
import {
  cronExpressionBuilderEmits,
  cronExpressionBuilderProps,
} from './config'

defineOptions({ name: 'LlCronExpressionBuilder' })
// namespace
const bem = createNamespace('cron-expression-builder')
//props
const props = defineProps(cronExpressionBuilderProps)
//emits
const emits = defineEmits(cronExpressionBuilderEmits)

const editCronValue = ref(props.value)
const formItemContext = Form.useInjectFormItemContext()
const modalRef = ref()

watch(
  () => props.value,
  (newVal) => {
    if (newVal !== editCronValue.value) {
      editCronValue.value = newVal
    }
  }
)

function showConfigModal() {
  if (props.disabled) return
  modalRef.value?.openModal()
}
function handleSubmit() {
  emits('change', editCronValue.value)
  emits('update:value', editCronValue.value)
  formItemContext.onFieldChange()
}
</script>
<!-- 
<style lang="less">
@import 'easy.cron.input.less';
@import './index.less';
</style> -->
